import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GraphqlFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GraphqlFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.12 10.14q-.12-.165-.27-.3l-7.53-7.49q-.12-.12-.24-.21c-.14-.08-.3-.12-.47-.13H8.98a4.21 4.21 0 0 0-4.21 4.15v20.12c0 2.2 1.73 3.73 4.21 3.73h14.03c2.47 0 4.21-1.53 4.21-3.73V10.84c.03-.24 0-.47-.1-.69Zm-2.75 16.13c0 .76-.76.97-1.4.97H8.98c-.64 0-1.4-.18-1.4-.97V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.03 2.33 2.32 2.34h5.13v14.04Zm-7.19-12.51c.04-.11.06-.22.07-.34a1.261 1.261 0 0 0-2.52 0c0 .12.03.23.07.34l-2.92 1.69c-.23-.25-.56-.39-.9-.39-.68.02-1.23.57-1.23 1.26 0 .58.41 1.07.97 1.19v3.4c-.56.12-.97.62-.97 1.2 0 .69.56 1.25 1.25 1.25.34 0 .67-.14.9-.39l2.92 1.7c-.23.66.12 1.37.78 1.6s1.37-.12 1.6-.78c.09-.26.09-.55 0-.82l2.92-1.7c.23.25.56.39.9.39.69 0 1.25-.55 1.26-1.24 0-.58-.41-1.08-.97-1.2v-3.4c.56-.12.97-.61.97-1.19 0-.69-.56-1.26-1.26-1.26-.34 0-.67.14-.9.39l-2.95-1.69Zm2.64 2.22c-.04.11-.07.22-.07.34 0 .58.41 1.07.97 1.19v3.4l-3.8-6.6 2.89 1.67Zm0 5.85h-7.65c-.05-.23-.16-.44-.33-.6l3.81-6.6c.22.09.46.09.68 0l3.81 6.6c-.17.16-.28.37-.33.6Zm-4.73-7.52-3.8 6.6v-3.4c.56-.12.97-.61.97-1.19 0-.12-.03-.23-.07-.34l2.89-1.67Zm1.81 9.85c-.23-.25-.56-.39-.91-.39-.34 0-.67.14-.91.39l-2.92-1.69v-.05h7.64v.05z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M3.54 16.86c-.63 0-1.14-.51-1.14-1.14V4.29C2.4 2.4 3.94.86 5.83.86h13.71c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.8-8.81H5.83c-.63 0-1.14.51-1.14 1.14v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.69 16.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V2a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM3 23.83c0-2.64 2.04-4.59 4.79-4.59 1.07 0 2.05.22 2.95.69v2.13c-.82-.42-1.8-.7-2.78-.7-1.57 0-2.62 1.01-2.62 2.48 0 1.56 1.05 2.5 2.36 2.5.92 0 1.67-.47 1.88-1.43H7.44v-1.77h4.43v1.02c0 2.58-1.85 4.28-4.19 4.28-2.75 0-4.67-1.95-4.67-4.6ZM16.05 28.3c-2.11-.47-3.56-2.25-3.56-4.47 0-2.64 2-4.59 4.75-4.59s4.74 1.96 4.74 4.59c0 2.26-1.44 4-3.56 4.47.14.46.52.66.98.66.33 0 .69-.09 1.02-.23v1.98c-.42.2-1 .28-1.38.28-1.67 0-2.9-.97-2.99-2.69m3.6-4.47c0-1.44-1.08-2.48-2.41-2.48s-2.41 1.03-2.41 2.48 1.09 2.48 2.41 2.48 2.41-1.03 2.41-2.48M23.01 19.36h2.29v6.84h3.93v2.09h-6.22z"
      })]
    })
  }));
};
GraphqlFileIcon.displayName = 'GraphqlFileIcon';